import { useState, useEffect } from 'react';
import {
    Routes, Route, Navigate, useNavigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import EmployeeDashboard from '../EmployeeDashboard';
import ShiftlineSelection from '../ShiftlineSelection';
import BidProfileSummary from '../BidProfileSummary';
import BidProfileSummaryMobile from '../BidProfileSummary/BidProfileSummaryMobile';
import ShiftlineTemplateSelection from '../ShiftlineTemplateSelection';
import LogoutWarning from '../../components/LogoutWarning';
import ScrollToTop from '../../components/ScrollToTop';

// Application Styles
import './App.scss';

function App() {
    /** @type {ShiftBidding.EmployeeStore} */
    // @ts-ignore
    const { employeeBidProfile, employeeBidSelectionTemplate } = useSelector((state) => state);
    const navigate = useNavigate();

    const isBiddingSelected = employeeBidProfile.profileId !== '';
    const isTemplateSelected = employeeBidSelectionTemplate.sourceProfileId !== '';
    const [windowWidth, setWindowWidth] = useState(0);
    useEffect(() => {
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const isMobile = windowWidth < 992;
    const renderShiftSummary = isMobile
        ? <BidProfileSummaryMobile onBack={() => navigate('/Employee')} />
        : <BidProfileSummary onBack={() => navigate('/Employee')} />;

    return (
        <>
            <LogoutWarning />
            <ScrollToTop />
            <Routes>
                <Route
                    path=""
                    element={
                        <EmployeeDashboard />
                    }
                />
                <Route
                    path="bid"
                    element={isBiddingSelected ? <ShiftlineSelection /> : <Navigate to="/employee" />}
                />
                <Route
                    path="summary"
                    element={isBiddingSelected ? renderShiftSummary : <Navigate to="/employee" />}
                />
                <Route
                    path="template"
                    element={isTemplateSelected ? <ShiftlineTemplateSelection /> : <Navigate to="/employee" />}
                />
            </Routes>
        </>
    );
}

export default App;
